module.exports = __webpack_public_path__ + "src/img/ziyuan.d93f6a49.svg";